import { useEffect, useState } from "react";

export const useSortAttributes = () => {
  const [sortAttributes, setSortAttributes] = useState({ field: "name", asc: false });
  const [rowsAttributes, setRowsAttributes] = useState();

  const sortedAttributes = (attributes) => {
    let sortedAttributes = [...attributes];

    switch (sortAttributes.field) {
      case "name":
        sortedAttributes.sort((a, b) => (a?.name?.toLowerCase() < b?.name?.toLowerCase() ? 1 : -1));
        sortAttributes.asc && sortedAttributes.reverse();
        sortedAttributes = [
          ...sortedAttributes.filter((attr) => attr.name),
          ...sortedAttributes.filter((attr) => !attr.name),
        ];
        return sortedAttributes;
      case "type":
        sortedAttributes.sort((a, b) => {
          const aType = a.internal ? "internal" : "external";
          const bType = b.internal ? "internal" : "external";
          return aType.toLowerCase() < bType.toLowerCase() ? 1 : -1;
        });
        sortAttributes.asc && sortedAttributes.reverse();
        return sortedAttributes;
      case "description":
        sortedAttributes.sort((a, b) => (a?.description?.toLowerCase() < b?.description?.toLowerCase() ? 1 : -1));
        sortAttributes.asc && sortedAttributes.reverse();
        sortedAttributes = [
          ...sortedAttributes.filter((attr) => attr.description),
          ...sortedAttributes.filter((attr) => !attr.description),
        ];
        return sortedAttributes;
      case "component":
        sortedAttributes.sort((a, b) => (a?.componentName?.toLowerCase() < b?.componentName?.toLowerCase() ? 1 : -1));
        sortAttributes.asc && sortedAttributes.reverse();
        sortedAttributes = [
          ...sortedAttributes.filter((attr) => attr.componentName),
          ...sortedAttributes.filter((attr) => !attr.componentName),
        ];
        return sortedAttributes;
      case "importance":
        sortedAttributes.sort((a, b) => (a?.importance < b?.importance ? 1 : -1));
        sortAttributes.asc && sortedAttributes.reverse();
        sortedAttributes = [
          ...sortedAttributes.filter((attr) => attr.importance !== undefined),
          ...sortedAttributes.filter((attr) => attr.importance === undefined),
        ];
        return sortedAttributes;
      case "project":
        sortedAttributes.sort((a, b) => (a?.productName?.toLowerCase() < b?.productName?.toLowerCase() ? 1 : -1));
        sortAttributes.asc && sortedAttributes.reverse();
        sortedAttributes = [
          ...sortedAttributes.filter((attr) => attr.productName),
          ...sortedAttributes.filter((attr) => !attr.productName),
        ];
        return sortedAttributes;
      default:
        console.warn("Couldn't sort field ", sortAttributes.field);
        break;
    }
  };

  const handleSortChangeAttributes = (field) => {
    field === sortAttributes.field
      ? setSortAttributes({ field, asc: !sortAttributes.asc })
      : setSortAttributes({ field, asc: true });
  };

  useEffect(() => {
    if (rowsAttributes?.length) {
      setRowsAttributes(sortedAttributes(rowsAttributes));
    }
  }, [sortAttributes]);

  return {
    sortAttributes,
    rowsAttributes,

    sortedAttributes,
    handleSortChangeAttributes,
    setRowsAttributes,
  };
};
